import { joinChannel } from './ws-actions';
import { getChannel } from '../services/ws-channel';
import { showNewPostMessageDebounced } from './show-new-post-message';

export const emitOpenCategory = category => joinChannel(getChannel({ type: 'category', ...category }));

export const NEW_POST = 'post/NEW';
export const SOCKET_NEW_POST = 'new post';
export const UPDATE_POST_COUNTERS = 'post/UPDATE_POST_COUNTERS';
export const SOCKET_UPDATE_POST_COUNTERS = 'update post counters';

export const UPDATE_CATEGORY_COUNTERS = 'category/UPDATE_CATEGORY_COUNTERS';
export const SOCKET_UPDATE_CATEGORY_COUNTERS = 'update category counters';

export const newPost = payload => dispatch => {
  dispatch({
    type: NEW_POST,
    payload,
  });
  dispatch(showNewPostMessageDebounced(payload._id));
};

export const updatePostCounters = payload => dispatch =>
  dispatch({
    type: UPDATE_POST_COUNTERS,
    payload,
  });

export const updateCategoryCounters = payload => dispatch =>
  dispatch({
    type: UPDATE_CATEGORY_COUNTERS,
    payload,
  });



// WEBPACK FOOTER //
// ./app/actions/category-socket.js